import React from 'react';
import { get } from 'lodash';
import {
  Button,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import DynamicIcon from 'components/Common/DynamicIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles((theme) => ({
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  tooltip: {
    fontSize: 12,
  },
}));

const formBodyReducer = (formBody) => {
  const tempFormBody = Object.assign({}, formBody);

  delete tempFormBody.id;
  return tempFormBody;
};

const ActionCell = ({
  row,
  column,
  baseDeepLink,
  handleDeeplink,
  rowState,
  rowIndex,
  rowKey,
  fetchRows,
  setMessage,
}) => {
  const classes = useStyles();
  const actions = [
    ...(Array.isArray(row[column.key]) ? row[column.key] : []).filter(
      (action) => action.critical
    ),
    ...(Array.isArray(row[column.key]) ? row[column.key] : []).filter(
      (action) => !action.critical
    ),
  ];

  const regularActionsCount = actions.length > 3 ? 2 : 3;

  const regularActions = actions.slice(0, regularActionsCount);
  const dropDownList = actions.slice(regularActionsCount);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const actionClickHandler = (action) => {
    handleDeeplink(action.deep_link, action.apiType || 1, {
      [rowKey || 'row']: formBodyReducer(rowState),
    });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.actionContainer}>
      {(regularActions || []).map((action, actionIndex) =>
        action.textOnly ? (
          <Button
            style={{
              marginRight: 5,
              color: action.buttonColor || '#2e6bcf',
              maxWidth: 250,
              borderRadius: 5,
            }}
            onClick={() => actionClickHandler(action)}
          >
            <div
              style={{
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                fontSize: 16,
              }}
            >
              {action.title}
            </div>
          </Button>
        ) : action.showText ? (
          <Button
            variant="contained"
            color="primary"
            style={{
              marginRight: 5,
              marginLeft: 5,
              background:
                action.buttonColor ||
                `transparent linear-gradient(2deg, 
            '#2896E9' 0%, '#7467F0' 100%) 0% 0% no-repeat padding-box`,
              color: '#ffffff',
              paddingLeft: 5,
              paddingRight: 5,
              height: 40,
              maxWidth: 250,
              borderRadius: 5,
            }}
            onClick={() => actionClickHandler(action)}
          >
            <DynamicIcon
              iconId={action.iconId}
              insideColoredButton
              style={{
                height: 20,
                width: 20,
                color: '#ffffff',
                marginLeft: 10,
                fontSize: 15,
              }}
            />
            <div
              style={{
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                marginLeft: 5,
                marginRight: 10,
                color: '#ffffff',
              }}
            >
              {action.title}
            </div>
          </Button>
        ) : (
          <Tooltip
            title={action.title || action.name}
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <IconButton
              key={actionIndex}
              onClick={() => actionClickHandler(action)}
              style={{
                backgroundColor: action.buttonColor || '#7467F0',
                borderRadius: 5,
                color: '#ffffff',
                width: 30,
                height: 30,
                marginRight: 5,
                dilspay: 'flex',
                alignItems: 'center',
              }}
            >
              <DynamicIcon
                iconId={action.iconId}
                style={{ height: 20, width: 20, color: '#ffffff' }}
                insideColoredButton={true}
              />
            </IconButton>
          </Tooltip>
        )
      )}
      {(dropDownList || []).length > 0 && (
        <>
          <Tooltip title="More Actions">
            <IconButton
              style={{
                backgroundColor: row[column.key].buttonColor || '#7467F0',
                borderRadius: 5,
                color: '#ffffff',
                width: 30,
                height: 30,
                marginRight: 5,
                dilspay: 'flex',
                alignItems: 'center',
              }}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <MoreVertIcon style={{ color: '#ffffff', fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <Popover
            id="long-menu"
            anchorEl={anchorEl}
            keepMounted
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={!!anchorEl}
            onClose={handleCloseMenu}
            PaperProps={{
              style: {
                width: '20ch',
                padding: '5px 0px',
              },
            }}
          >
            {(dropDownList || []).map((action) => (
              <MenuItem
                key={action}
                onClick={() => {
                  actionClickHandler(action);
                  handleCloseMenu();
                }}
              >
                <DynamicIcon
                  iconId={action.iconId}
                  style={{ height: 25, width: 25, marginRight: 10 }}
                />
                {action.title || action.name}
              </MenuItem>
            ))}
          </Popover>
        </>
      )}
    </div>
  );
};

export default ActionCell;
